/**
 * @license
 * Copyright (c) Peculiar Ventures, LLC.
 *
 * This source code is licensed under the BSD 3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { FunctionalComponent, h } from '@stencil/core';
import { Typography } from '@peculiar/certificates-viewer';
import { getString } from '../../utils/l10n';
import { FortifyStatus } from '../fortify-status';
import { FortifyButton } from '../fortify-button';

export interface IFortifyChallengeNotApprovedProps {
  onCancel: (event: MouseEvent) => void;
  onTryAgain: (event: MouseEvent) => void;
}

export const FortifyChallengeNotApproved: FunctionalComponent<IFortifyChallengeNotApprovedProps> = (
  props,
) => {
  const { onCancel, onTryAgain } = props;

  const title = getString(
    'approve.title',
    {
      pattern: '{origin}',
      replacer: (
        <Typography
          variant="h4"
          color="secondary"
        >
          {window.location.origin}
        </Typography>
      ),
    },
  );

  return (
    <FortifyStatus
      title={title}
      description={getString('approve.description')}
    >
      <FortifyButton
        onClick={onCancel}
      >
        {getString('actions.cancel')}
      </FortifyButton>
      <FortifyButton
        variant="primary"
        onClick={onTryAgain}
      >
        {getString('actions.tryAgain')}
      </FortifyButton>
    </FortifyStatus>
  );
};
